import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[lng]/AireAcondicionadosDePrecision/page.js");
